import React from 'react';
import PageHero from '../components/PageHero';
import Marketplaces from '../components/Marketplaces';
import BrandsMarquee from '../components/BrandsMarquee';
import { heroImages } from '../mock';

export default function MarketplacesPage() {
  return (
    <>
      <PageHero
        eyebrow="Marketplaces"
        title="Sell on Every Marketplace That Matters"
        sub="We manage seller accounts on Amazon, Flipkart, Meesho, Myntra, eBay, Etsy, JioMart, ShopClues and more — both Indian and global."
        image={heroImages.analytics}
      />
      <BrandsMarquee />
      <Marketplaces />
    </>
  );
}
